export const beyondGateway = '192.168.168.1';

export const roles = ['admin', 'user'];
